// * FYI: these values are used in the useIacManagementResources hook to filter the data
export enum IacManagementGroupBy {
  Stack = "stack",
  Provider = "provider",
  Type = "type",
}
